import dayjs from "dayjs";
import isBetween from 'dayjs/plugin/isBetween';
import duration from 'dayjs/plugin/duration';
dayjs.extend(isBetween);
dayjs.extend(duration);

export function isInChristmasRange(date: Date) {
    const inputDate = dayjs(date);
    const year = inputDate.year();

    // Definir el rango de fechas
    const startOfRange = dayjs(`${year}-12-10`); // 10 de diciembre del año actual
    const endOfRange = dayjs(`${year + 1}-01-02`).endOf('day'); // 2 de enero del año siguiente

    // Si estamos entre diciembre y enero, ajustar el año del rango
    if (inputDate.month() === 11) {
        // Si estamos en diciembre
        return inputDate.isBetween(startOfRange, endOfRange, null, '[]');
    }
    if (inputDate.month() === 0) {
        // Si estamos en enero
        const startOfRangePreviousYear = dayjs(`${year - 1}-12-20`);
        const endOfRangeThisYear = dayjs(`${year}-01-02`).endOf('day');
        return inputDate.isBetween(
            startOfRangePreviousYear,
            endOfRangeThisYear,
            null,
            '[]',
        );
    }

    // Fuera de los meses de diciembre y enero
    return false;
}

export function isInSnowyChristmasRange(date: Date) {
    const inputDate = dayjs(date);
    const year = inputDate.year();

    // Definir el rango de fechas
    const startOfRange = dayjs(`${year}-12-10`); // 10 de diciembre del año actual
    const endOfRange = dayjs(`${year + 1}-01-02`).endOf('day'); // 2 de enero del año siguiente

    // Si estamos entre diciembre y enero, ajustar el año del rango
    if (inputDate.month() === 11) {
        // Si estamos en diciembre
        return inputDate.isBetween(startOfRange, endOfRange, null, '[]');
    }
    if (inputDate.month() === 0) {
        // Si estamos en enero
        const startOfRangePreviousYear = dayjs(`${year - 1}-12-20`);
        const endOfRangeThisYear = dayjs(`${year}-01-02`).endOf('day');
        return inputDate.isBetween(
            startOfRangePreviousYear,
            endOfRangeThisYear,
            null,
            '[]',
        );
    }

    // Fuera de los meses de diciembre y enero
    return false;
}


export function isIn4thOfJulyRange(date: Date) {
    const inputDate = dayjs(date);
    const year = inputDate.year();

    // Definir el rango de fechas
    const startOfRange = dayjs(`${year}-06-30`); // 1 de julio
    const endOfRange = dayjs(`${year}-07-05`).endOf('day'); // 5 de julio

    return inputDate.isBetween(
        startOfRange,
        endOfRange,
        null,
        '[]',
    );
}

export function isInEasterRange(date: Date) {
    const inputDate = dayjs(date);
    const year = inputDate.year();

    // Definir el rango de fechas
    const startOfRange = dayjs(`${year}-03-30`); // 30 de marzo
    const endOfRange = dayjs(`${year}-04-06`).endOf('day'); // 6 de abril

    return inputDate.isBetween(
        startOfRange,
        endOfRange,
        null,
        '[]',
    );
}



export function isInHalloweenRange(date: Date) {
    const inputDate = dayjs(date);
    const year = inputDate.year();

    // Definir el rango de fechas
    const startOfRange = dayjs(`${year}-10-27`); // 27 de octubre
    const endOfRange = dayjs(`${year}-11-01`).endOf('day'); // 1 de noviembre

    return inputDate.isBetween(
        startOfRange,
        endOfRange,
        null,
        '[]',
    );
}

export function formatTimeInStage(stageUpdatedAt: Date | string | null | undefined): string {
    if (!stageUpdatedAt) return "—";
    const diffMs = dayjs().diff(dayjs(stageUpdatedAt));
    const d = dayjs.duration(diffMs);
    const days = Math.floor(d.asDays());
    const hours = d.hours();
    const minutes = d.minutes();

    if (days > 0) {
        return days === 1 ? "1 day" : `${days} days`;
    }
    if (hours > 0) {
        return hours === 1 ? "1 hr" : `${hours} hrs`;
    }
    return minutes <= 1 ? "1 min" : `${minutes} mins`;
}

export function isInThanksgivingRange(date: Date) {
    const inputDate = dayjs(date);
    const year = inputDate.year();

    // Definir el rango de fechas
    const startOfRange = dayjs(`${year}-11-20`); // 20 de noviembre
    const endOfRange = dayjs(`${year}-11-29`).endOf('day'); // 29 de noviembre

    return inputDate.isBetween(
        startOfRange,
        endOfRange,
        null,
        '[]',
    );

}

export function isInCincoDeMayoRange(date: Date) {
    const inputDate = dayjs(date);
    const year = inputDate.year();

    // Definir el rango de fechas
    const startOfRange = dayjs(`${year}-05-04`); // 5 de mayo
    const endOfRange = dayjs(`${year}-05-10`).endOf('day'); // 10 de mayo

    return inputDate.isBetween(
        startOfRange,
        endOfRange,
        null,
        '[]',
    );

}